﻿class PromoPopup extends HTMLElement {
  constructor() {
    super();
    if (window.location.pathname === '/challenge') return;

    this.sectionId   = this.dataset.sectionId;
    this.trigger     = this.dataset.trigger     || 'delay';
    this.delay       = parseInt(this.dataset.delay)  || 5;
    this.scrollPct   = parseInt(this.dataset.scroll) || 40;
    this.cookieName  = this.dataset.cookieName  || 'sox:promo';
    this.cookieDays  = parseInt(this.dataset.cookieDays) || 7;
    this.showOnce    = this.dataset.showOnce === 'true';
    this.schedStart  = this.dataset.scheduleStart || '';
    this.schedEnd    = this.dataset.scheduleEnd   || '';

    this.dialog  = this.querySelector('.promo-popup__dialog');
    this.overlay = this.querySelector('.promo-popup__overlay');

    if (!this.dialog) return;
    if (!this._withinSchedule()) return;
    if (this._cookieSet()) return;

    this._bindClose();
    this._bindCopyCode();
    this._watchFormSuccess();
    this._initTrigger();
  }

  _withinSchedule() {
    const now = Date.now();
    if (this.schedStart) {
      const start = new Date(this.schedStart).getTime();
      if (!isNaN(start) && now < start) return false;
    }
    if (this.schedEnd) {
      const end = new Date(this.schedEnd).getTime();
      if (!isNaN(end) && now > end) return false;
    }
    return true;
  }

  _cookieSet() {
    return document.cookie.split(';').some(c => c.trim().startsWith(this.cookieName + '='));
  }

  _setCookie() {
    const maxAge = this.showOnce
      ? 365 * 24 * 60 * 60
      : this.cookieDays * 24 * 60 * 60;
    document.cookie = `${this.cookieName}=1; max-age=${maxAge}; path=/; SameSite=Lax`;
  }

  _initTrigger() {
    switch (this.trigger) {
      case 'immediate':
        this._open();
        break;
      case 'delay':
        setTimeout(() => this._open(), this.delay * 1000);
        break;
      case 'scroll':
        this._watchScroll();
        break;
      case 'exit':
        this._watchExitIntent();
        break;
      default:
        setTimeout(() => this._open(), this.delay * 1000);
    }
  }

  _watchScroll() {
    const onScroll = () => {
      const scrolled = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
      if (scrolled >= this.scrollPct) {
        window.removeEventListener('scroll', onScroll);
        this._open();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  _watchExitIntent() {
    const onMouseLeave = (e) => {
      if (e.clientY <= 0) {
        document.removeEventListener('mouseleave', onMouseLeave);
        this._open();
      }
    };
    document.addEventListener('mouseleave', onMouseLeave);
  }

  _open() {
    document.body.style.overflow = 'hidden';
    this.dialog.classList.add('is-open');
    this.overlay.classList.add('is-visible');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.dialog.classList.add('is-visible');
      });
    });
    this.dialog.setAttribute('aria-hidden', 'false');
    const firstFocusable = this.dialog.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) setTimeout(() => firstFocusable.focus(), 100);
  }

  _close() {
    this._setCookie();
    this.dialog.classList.remove('is-visible');
    this.overlay.classList.remove('is-visible');
    setTimeout(() => {
      this.dialog.classList.remove('is-open');
      document.body.style.overflow = '';
    }, 350);
    this.dialog.setAttribute('aria-hidden', 'true');
  }

  _bindClose() {
    this.querySelectorAll('[data-promo-close]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this._close();
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.dialog.classList.contains('is-open')) {
        this._close();
      }
    });
  }

  _bindCopyCode() {
    const btn = this.querySelector('[data-copy-code]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const code = btn.dataset.copyCode;
      navigator.clipboard.writeText(code).then(() => {
        btn.classList.add('is-copied');
        setTimeout(() => btn.classList.remove('is-copied'), 2500);
      });
    });
  }

  _watchFormSuccess() {
    const success = this.querySelector('.promo-popup__success');
    if (success) {
      this._open();
      setTimeout(() => this._close(), 4000);
    }
  }
}

customElements.define('promo-popup', PromoPopup);